import { DomElementButton } from "./DomElementButton";
import { DomElementInteractionEvent } from "./DomElementInteractionEvent";
import { DomElementToggleState } from "./DomElementToggleState";
import { DomLayerElementInterface } from "../config/DomLayerElementInterface";
import { DomElementFrameInterface } from "../config/DomElementFrameInterface";
import { DomLayer } from "../dom-layer";
import { DomElementInteractionEventTypes } from "./DomElementInteractionEventTypes";

export class DomElementToggle extends DomElementButton {
    protected titleToggledOff?: string | undefined;
    protected assetToggledOff: string | undefined;
    protected _state: DomElementToggleState = DomElementToggleState.ON; // by deafult, set to on

    constructor(
        domLayer: DomLayer,
        imageDirPath: string,
        options: DomLayerElementInterface,
        defaultOptions: DomLayerElementInterface,
        frames: DomElementFrameInterface[]
    ) {
        super(domLayer, imageDirPath, options, defaultOptions, frames);
        this.postInit();
    }

    public get state(): DomElementToggleState {
        return this._state;
    }

    public set state(value: DomElementToggleState) {
        // allows for control of setting property
        this._state = value;
    }

    public updateStateVariable(state: any[]) {
        super.updateStateVariable(state);
        if (this.stateVariable) this.toggleState(false, state[1]);
    }

    protected applyOptions(
        options: DomLayerElementInterface,
        defaultOptions: DomLayerElementInterface,
        frames: DomElementFrameInterface[]
    ) {
        super.applyOptions(options, defaultOptions, frames);
        const frameData: DomElementFrameInterface = this.getFrameByName(options.frame, frames);
        const assetToggledOff: string = this.getAssetWithSuffix(options.assetToggledOff, frameData);
        this.assetToggledOff = assetToggledOff;
        this.titleToggledOff = options.titleToggledOff;
    }

    protected postInit() {
        if (this.stateVariable) {
            const stateName = this.stateVariable[0];
            const stateValue = this.stateVariable[1];
            const globalStateValue = this.domLayer.getStateVariable(stateName);
            if (globalStateValue !== stateValue) this.toggleState(false);
        }
    }

    protected onClick(event: MouseEvent | TouchEvent) {
        this.toggleState();
        super.onClick(event);
    }

    protected onTouchEnd(event: MouseEvent | TouchEvent) {
        this.toggleState();
        super.onTouchEnd(event);
    }

    protected toggleState(setStateVariable?: boolean, forcedState?: boolean) {
        if (typeof setStateVariable === "undefined") setStateVariable = true;
        let assetFileName: string | undefined;
        let imagePath: string;

        // switch the state value
        if (typeof forcedState === "undefined") {
            this.state =
                this.state === DomElementToggleState.ON
                    ? DomElementToggleState.OFF
                    : DomElementToggleState.ON;
        } else {
            this.state = forcedState ? DomElementToggleState.OFF : DomElementToggleState.ON;
        }

        // switch the toggle button image
        assetFileName = this.state === DomElementToggleState.ON ? this.asset : this.assetToggledOff;

        if (this.element) {
            imagePath = this.imageDirPath + assetFileName;
            this.element.style.backgroundImage = "url(" + imagePath + ")";
        }

        // switch the accessible title
        this.currentTitle =
            this.state === DomElementToggleState.ON ? this.title : this.titleToggledOff;

        // change the state variable
        if (setStateVariable && this.stateVariable) {
            const stateName = this.stateVariable[0];
            const globalStateValue = this.domLayer.getStateVariable(stateName);
            this.domLayer.elementSetStateVariable(
                stateName,
                !globalStateValue,
                DomElementInteractionEventTypes.PointerTap
            );
        }
    }

    protected addToElementEvent(elementEvent: DomElementInteractionEvent) {
        elementEvent.toggleState = this.state;
    }
}
